import { LinePayPrime } from '../../../types/LinePayPrime';

export default {
  redirect(url: string): void {
    location.href = url;
  },
  onPaid(_transactionID: number, data: LinePayPrime): void {
    this.redirect(data.redirect_url);
  },
};
